angular.module('search').controller('SearchController', SearchController);

/* @ngInject */
function SearchController(
  $scope,
  $window,
  $analytics,
  $stateParams,
  $timeout,
  offer,
  tribe,
  Authentication,
  FiltersService,
  messageCenterService,
  LocationService,
) {
  // ViewModel
  const vm = this;

  // Exposed to the view
  // Sidebar visible: registered users on bigger screens
  // Sidebar hidden: on small screens and un-registered users
  vm.isSidebarOpen =
    ($stateParams.offer && offer) ||
    (Authentication.user &&
      Authentication.user.public &&
      $window.innerWidth >= 768);
  vm.screenWidth = $window.innerWidth;
  vm.offer = offer || false;
  vm.filters = FiltersService.get();
  vm.toggleSidebar = toggleSidebar;
  vm.closeSidebar = closeSidebar;
  vm.openSidebar = openSidebar;
  vm.onPlaceSearch = onPlaceSearch;
  vm.openSearchPlaceInput = openSearchPlaceInput;
  vm.onLanguageFiltersChange = onLanguageFiltersChange;
  vm.onSeenFilterChange = onSeenFilterChange;
  vm.onlineInPast6Months = vm.filters.seen && vm.filters.seen.months === 6;
  // Arriving with a place to search opens the host list straight away
  vm.sidebarTab = $stateParams.location ? 'results' : 'filters';

  // Host list in the sidebar: the map's visible area, the searched place's
  // centre (for distances) and a filters snapshot the list refetches on
  vm.resultsBounds = null;
  vm.resultsCenter = null;
  vm.resultsFilters = angular.toJson(vm.filters);

  // Stay filters (dates and guests) as the sidebar form edits them:
  // native date inputs want `Date` objects, the filters cache keeps strings.
  vm.stay = { checkIn: null, checkOut: null, guests: null };
  vm.today = toIsoDate(new Date());
  vm.onStayFilterChange = onStayFilterChange;
  vm.clearStayFilters = clearStayFilters;
  vm.hasStayFilters = hasStayFilters;
  vm.minCheckOut = minCheckOut;

  // Visibility toggle for search place input on small screens
  vm.isPlaceSearchVisible = false;

  // Init search from the URL, `tr-location` directive attached
  // to search input will take care of the rest.
  // `Replacing underscore with space is to make search queries
  // coming from Hitchwiki/Nomadwiki/Trashwiki work
  // @link https://github.com/Hitchwiki/hitchwiki/issues/61
  // @link https://github.com/Trustroots/trustroots/issues/113
  vm.searchQuery = $stateParams.location
    ? $stateParams.location.replace('_', ' ', 'g').replace('+', ' ', 'g')
    : '';

  activate();

  /**
   * Initialize controller
   */
  function activate() {
    // If tribe was requested from URL, set it active
    if (tribe && tribe._id) {
      vm.filters.tribes = [tribe._id];
      FiltersService.set('tribes', [tribe._id]);
    }

    activateStayFilters();
    syncResultsFilters();

    if (
      angular.isDefined(vm.searchQuery) &&
      angular.isString(vm.searchQuery) &&
      vm.searchQuery
    ) {
      LocationService.suggestions(vm.searchQuery).then(function (suggestions) {
        if (suggestions.length) {
          const bounds = LocationService.getBounds(suggestions[0]);
          onPlaceSearch(bounds, 'bounds');
          vm.searchQuery = suggestions[0].trTitle;
          vm.resultsCenter = LocationService.getCenter(suggestions[0]) || null;
        }
      });
    }

    // The map reports the area it shows; the host list follows it
    $scope.$on('search.boundsChanged', function (event, bounds) {
      vm.resultsBounds = bounds;
    });

    // Watch for changes at types filters
    $scope.$watchCollection(
      'search.filters.types',
      function (newTypesFilters, oldTypesFilters) {
        if (!angular.equals(newTypesFilters, oldTypesFilters)) {
          // Save new value to cache
          FiltersService.set('types', newTypesFilters);
          onFiltersUpdated();
        }
      },
    );

    // Watch for changes at tribes filters
    $scope.$watchCollection(
      'search.filters.tribes',
      function (newTribeFilters, oldTribeFilters) {
        if (!angular.equals(newTribeFilters, oldTribeFilters)) {
          // Save new value to cache
          FiltersService.set('tribes', newTribeFilters);
          onFiltersUpdated();
        }
      },
    );

    // `SearchMap` controller sends these signals down to this controller
    $scope.$on('search.loadingOffer', function () {
      vm.offer = false;
      vm.loadingOffer = true;
    });
    $scope.$on('search.previewOffer', function (event, offer) {
      vm.offer = offer;
      vm.loadingOffer = false;
      openSidebar('results');
    });
    $scope.$on('search.closeOffer', function () {
      vm.offer = false;
      vm.loadingOffer = false;
    });

    // Initializing either location search or offer
    if ($stateParams.offer && !vm.offer) {
      // Offer not found or other error
      messageCenterService.add(
        'danger',
        'Sorry, we did not find what you are looking for.',
      );
      $analytics.eventTrack('offer-not-found', {
        category: 'search.map',
        label: 'Offer not found',
      });
    }
  }

  /**
   * Set up stay filters from the URL (e.g. the home page search) or,
   * failing that, from the cached filters. Cached dates that have already
   * passed are dropped so an old search does not silently hide hosts.
   */
  function activateStayFilters() {
    const urlCheckIn = fromIsoDate($stateParams.checkIn);
    const urlCheckOut = fromIsoDate($stateParams.checkOut);
    const urlGuests = parseInt($stateParams.guests, 10);
    const hasValidUrlGuests = urlGuests > 0 && urlGuests <= 99;

    if (urlCheckIn || urlCheckOut || hasValidUrlGuests) {
      vm.stay = {
        checkIn: urlCheckIn,
        checkOut: urlCheckOut,
        guests: hasValidUrlGuests ? urlGuests : null,
      };
    } else {
      const cachedDates = vm.filters.dates || {};
      vm.stay = {
        checkIn: fromIsoDate(cachedDates.checkIn),
        checkOut: fromIsoDate(cachedDates.checkOut),
        guests: vm.filters.guests > 0 ? vm.filters.guests : null,
      };
    }

    if (vm.stay.checkIn && toIsoDate(vm.stay.checkIn) < vm.today) {
      vm.stay.checkIn = null;
      vm.stay.checkOut = null;
    }

    // Store without broadcasting: the map reads filters when it initializes
    saveStayFilters();
  }

  /**
   * Fired for changes at stay filters (dates and guests)
   */
  function onStayFilterChange() {
    // Native date inputs set the model to `undefined` while invalid
    if (!angular.isDate(vm.stay.checkIn)) {
      vm.stay.checkIn = null;
    }
    if (!angular.isDate(vm.stay.checkOut)) {
      vm.stay.checkOut = null;
    }

    // A stay needs at least one night: push check-out past check-in
    if (
      vm.stay.checkIn &&
      vm.stay.checkOut &&
      vm.stay.checkOut <= vm.stay.checkIn
    ) {
      vm.stay.checkOut = addDays(vm.stay.checkIn, 1);
    }

    saveStayFilters();
    onFiltersUpdated();
  }

  /**
   * Reset stay filters
   */
  function clearStayFilters() {
    vm.stay = { checkIn: null, checkOut: null, guests: null };
    saveStayFilters();
    onFiltersUpdated();
  }

  /**
   * Are any stay filters active?
   */
  function hasStayFilters() {
    return !!(vm.stay.checkIn || vm.stay.checkOut || vm.stay.guests);
  }

  /**
   * Earliest allowed check-out date (`YYYY-MM-DD`) for the date input
   */
  function minCheckOut() {
    return vm.stay.checkIn ? toIsoDate(addDays(vm.stay.checkIn, 1)) : vm.today;
  }

  /**
   * Write `vm.stay` into the filters object and cache.
   * Dates are only sent as a pair; a half-filled range filters nothing.
   */
  function saveStayFilters() {
    const guests =
      vm.stay.guests > 0 && vm.stay.guests <= 99
        ? Math.floor(vm.stay.guests)
        : 0;
    const dates =
      vm.stay.checkIn && vm.stay.checkOut
        ? {
            checkIn: toIsoDate(vm.stay.checkIn),
            checkOut: toIsoDate(vm.stay.checkOut),
          }
        : { checkIn: '', checkOut: '' };

    vm.filters.guests = guests;
    vm.filters.dates = dates;
    FiltersService.set('guests', guests);
    FiltersService.set('dates', dates);
  }

  /**
   * Local calendar date as `YYYY-MM-DD`
   */
  function toIsoDate(date) {
    const pad = n => String(n).padStart(2, '0');
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate())
    );
  }

  /**
   * `YYYY-MM-DD` to a local-midnight Date, or `null` for anything else
   */
  function fromIsoDate(value) {
    if (!angular.isString(value) || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return null;
    }
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    // Reject overflowed dates such as 2026-02-30
    return date.getMonth() === month - 1 ? date : null;
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  /**
   * Fired for changes at languages filters
   */
  function onLanguageFiltersChange(languages) {
    vm.filters.languages = languages;
    FiltersService.set('languages', languages);
    onFiltersUpdated();
  }

  /**
   * Fired for changes at seen filter
   */
  function onSeenFilterChange() {
    vm.filters.seen.months = vm.onlineInPast6Months ? 6 : 24;

    // `vm.filters.seen` is still out of sync at this point,
    // but in next cycle after `$timeout` we have updated version.
    $timeout(function () {
      // Save new value to cache
      FiltersService.set('seen', vm.filters.seen);

      onFiltersUpdated();
    });
  }

  /**
   * Closes offer when filters are changed and updates the map
   */
  function onFiltersUpdated() {
    // Close possible open offers
    if (vm.offer) {
      vm.offer = false;
      // Tells `SearchMapController` and `SearchSidebarController`
      // to close anything offer related
      $scope.$broadcast('search.closeOffer');
    }
    syncResultsFilters();
    $scope.$broadcast('search.filtersUpdated', vm.filters);
  }

  /**
   * Snapshot the filters for the host list, which refetches when it changes
   */
  function syncResultsFilters() {
    vm.resultsFilters = angular.toJson(vm.filters);
  }

  /**
   * Open search place input on small screens
   */
  function openSearchPlaceInput() {
    vm.isPlaceSearchVisible = true;

    closeSidebar();

    $timeout(function () {
      // Focus to search input
      angular.element('#search-query').focus();
    });
  }

  /**
   * Broadcast information about changed search location
   */
  function onPlaceSearch(data, type) {
    vm.isPlaceSearchVisible = false;

    if (data && type === 'center') {
      $scope.$broadcast('search.mapCenter', data);
    } else if (data && type === 'bounds') {
      $scope.$broadcast('search.mapBounds', data);
    }
  }

  /**
   * Toggles search results / filters sidebar
   */
  function toggleSidebar(activeTab) {
    if (vm.isSidebarOpen) {
      closeSidebar(activeTab);
    } else {
      openSidebar(activeTab);
    }
  }

  /**
   * Close search results / filters sidebar
   */
  function closeSidebar(activeTab) {
    vm.isSidebarOpen = false;

    // Close offer(s)
    $scope.$broadcast('search.closeOffer');

    // Activate specific tab
    if (activeTab) {
      vm.sidebarTab = activeTab;
    }
  }

  /**
   * Open search results / filters sidebar
   */
  function openSidebar(activeTab) {
    vm.isSidebarOpen = true;

    // Activate specific tab
    if (activeTab) {
      vm.sidebarTab = activeTab;
    }
  }
}
